module.exports = __webpack_public_path__ + "img/kbank.96128a9c.svg";